import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-student-work-card',
  templateUrl: './student-work-card.component.html',
  styleUrls: ['./student-work-card.component.scss']
})
export class StudentWorkCardComponent implements OnChanges, OnDestroy {
  @Input() profileData: any;

  workDescription: any;
  volHours: any;
  workFormsTouched = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileData'] !== undefined && changes['profileData'].currentValue !== undefined) {
      this.workDescription = changes['profileData'].currentValue.workDescription;
      this.volHours = changes['profileData'].currentValue.volunteerHours;
    }
  }

  getStudentWorkData() {
    return {workDes: this.workDescription, volHours: this.volHours}
  }
  changeValue () {
    this.workFormsTouched = true;
  }
  ngOnDestroy() {
    this.workFormsTouched = false;
  }
}
